// extracted by mini-css-extract-plugin
export var centerAligned = "BD05uzAwbCghpQ_Pb3Fj";
export var info = "d85QnG8ovrtbubCXHIhL";
export var leftBorder = "ivGXe5BROQI3PVrfHLOX";
export var negative = "_jpnyFj4Y_8NkVmnVXaE";
export var neutral = "c4rFfRBsAIUNzZCe1BaY";
export var positive = "iAyf22VFXE4kSjj7AEgL";
export var primary = "N_X6iChI_XYI9aKG4_Fp";
export var root = "iWt_1ejNb0SVJpSQUqfE";
export var secondary = "jchX3zw5qoxhPlJIotLo";
export var title = "cToKaXNjpUAMHlNxQm6Q";
export var warning = "tx8Q0edVGuueb9J8fMvN";
export var withChevron = "Bbi3Ws_NMIZvr1lwt5sQ";